/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const breakpoints = ["1em", "30em", "45em", "64em", "80em", "86em", "100em"];

const [xs, sm, md, xm, lg, ml, xl] = breakpoints;
breakpoints.xs = xs; // Mobile - 16px
breakpoints.sm = sm; // Mobile - 480px
breakpoints.md = md; // Tab Portrait - 720px
breakpoints.xm = xm; // Tab Landscape - 1024px
breakpoints.lg = lg; // Desktop - 1280px
breakpoints.ml = ml; // Monitor / Large Desktop - 1360px
breakpoints.xl = xl; // large monitor / 4k - 1600px

// #endregion
// #region typography

const fonts = {
  primaryLight: "NeometricLight",
  primaryRegular: "NeometricRegular",
  primaryMedium: "NeometricMedium",
  primaryBold: "NeometricBold",
  primaryExtraBold: "NeometricExtraBold",
};
// #endregion
// #region colors
const colorSets = [
  {
    name: "primary",
    colors: [
      { name: 50, hex: "#DBF0FF" },
      { name: 200, hex: "#B8D9F1" },
      { name: 500, hex: "#79A2C2" },
      { name: 700, hex: "#275775" },
      { name: 900, hex: "#023047" },
    ],
  },
  {
    name: "secondary",
    colors: [
      { name: 50, hex: "#FDF2E0" },
      { name: 200, hex: "#FADDB1" },
      { name: 500, hex: "#F1A126" },
      { name: 700, hex: "#EF9103" },
      { name: 900, hex: "#E57601" },
    ],
  },
  // netural to neutral
  {
    name: "neutral",
    colors: [
      { name: 50, hex: "#F5F5F5" },
      { name: 100, hex: "#E9E9E9" },
      { name: 200, hex: "#D9D9D9" },
      { name: 300, hex: "#C4C4C4" },
      { name: 400, hex: "#9D9D9D" },
      { name: 500, hex: "#7B7B7B" },
      { name: 600, hex: "#555555" },
      { name: 700, hex: "#434343" },
      { name: 800, hex: "#262626" },
      { name: 900, hex: "#000000" },
    ],
  },
  {
    name: "accents",
    colors: [
      { name: 100, hex: "#FF3816" },
      { name: 200, hex: "#0C625C" },
    ],
  },
  {
    name: "background",
    colors: [
      { name: 100, hex: "#F7FCFF" },
      { name: 200, hex: "#E4E4E4" },
    ],
  },
];

export const colors = colorSets.reduce(
  (colorMap, { name, alias = name, colors: colorSet }) => {
    const color = {};
    const cm = colorMap;
    for (let colorIndex = 0; colorIndex < colorSet.length; colorIndex++) {
      const { name: colorName, hex } = colorSet[colorIndex];
      color[colorIndex] = hex;
      color[colorName] = hex;
    }
    cm[name] = color;
    cm[alias] = color;
    return cm;
  },
  {
    // ...defaultTheme.colors,
    white: "#FFFFFF",
    "white.0": "#FFFFFF",
    black: "#000000",
    "black.0": "#000000",
  }
);

// #endregion
const radii = {
  small: "0.125rem",
  normal: "0.1875rem",
  large: "0.375rem",
  full: "10rem",
  square: 0,
};
const zIndices = {
  modal: 2000,
  tooltip: 5000,
  toast: 7000,
};

const shadows = [
  { name: "none", shadow: undefined },
  { name: "sm", shadow: "0px 4px 100px rgba(0, 0, 0, 0.08)" },
  { name: "m", shadow: "0px 10px 40px 0px rgba(0, 0, 0, 0.08)" },
  { name: "xl", shadow: "0px 4px 30px rgba(0, 0, 0, 0.1)" },
].reduce((shadowSet, { name, shadow }, index) => {
  const s = shadowSet;
  s[name] = shadow;
  s[index] = shadow;
  return s;
});

export const theme = {
  breakpoints,
  radii,
  colors,
  zIndices,
  shadows,
  fonts,
};
